module.exports = __webpack_public_path__ + "static/media/LogoLight.1a165d83.svg";